import { Button, Modal, ScrollArea, Table, Text } from "@mantine/core";
import { useState } from "react";

import DifficultyScore from "../../../../../components/Tax Pro Only/DifficultyScore/DifficultyScore";
import { IconChevronRight } from "@tabler/icons-react";
import classes from "@components/DocListTable/TableScrollArea.module.scss";
import "./SummaryModal.scss";
import ArchiveModal from "@components/Modals/ArchiveModal/ArchiveModal";
import { useClientNavigation } from "@/utils/hooks/useClientNavigation";

interface SummaryModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  title: string;
  description: string;
  clients: any[];
}

const SummaryModal = ({
  show,
  setShow,
  title,
  description,
  clients,
}: SummaryModalProps) => {
  const [scrolled, setScrolled] = useState(false);
  const [archivedModalOpen, setArchivedModalOpen] = useState(false);

  const { navigateToClient } = useClientNavigation();

  const TableHeight = 400;

  const handleViewProfile = (userId: string, client: any) => {
    navigateToClient(
      { userId, taxInfo: client?.taxInfo },
      {
        onArchived: () => setArchivedModalOpen(true),
        onBeforeNavigate: () => setShow(false),
      }
    );
  };

  const rows = clients?.map((client) => (
    <Table.Tr
      key={client.userId}
      className="clickable-row"
      onClick={() => handleViewProfile(client.userId, client)}
    >
      <Table.Td>
        <DifficultyScore isProfile={false} score={client?.difficulty} />
      </Table.Td>
      <Table.Td w={400}>
        <Text fw={700} c="#00477A">
          {client.firstName && client.lastName
            ? `${client.firstName} ${client.lastName}`
            : "Unnamed Client"}
        </Text>
      </Table.Td>
      <Table.Td>
        <Button
          variant="transparent"
          rightSection={<IconChevronRight />}
          onClick={(e) => {
            e.stopPropagation();
            handleViewProfile(client.userId, client);
          }}
        >
          View Profile
        </Button>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <>
      <Modal
        className="summary-modal"
        title={title}
        opened={show}
        size="xl"
        onClose={() => setShow(false)}
      >
        <p>{description}</p>
        <div>
          <ScrollArea.Autosize
            mah={TableHeight}
            onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
            style={{ borderRadius: "0.5rem", border: "1px solid #CDCDCD" }}
            className="scroll-area"
            w="100%"
          >
            <Table
              horizontalSpacing="md"
              verticalSpacing="md"
              withRowBorders={true}
              highlightOnHover={true}
              stickyHeader={true}
              className="client-list"
            >
              <Table.Thead
                className={`${classes.header} ${
                  scrolled ? classes.scrolled : ""
                }`}
              >
                <Table.Tr>
                  <Table.Th />
                  <Table.Th>Name</Table.Th>
                  <Table.Th />
                </Table.Tr>
              </Table.Thead>
              {clients?.length === 0 ? (
                <Table.Tbody>
                  <Table.Tr>
                    <Table.Td colSpan={5}>
                      <div className="no-clients-container">
                        <div className="no-clients-content">
                          <Text size="lg" fw={500} c="dimmed" mb="md">
                            No clients available.
                          </Text>
                        </div>
                      </div>
                    </Table.Td>
                  </Table.Tr>
                </Table.Tbody>
              ) : (
                <Table.Tbody>{rows}</Table.Tbody>
              )}
            </Table>
          </ScrollArea.Autosize>
        </div>
      </Modal>
      <ArchiveModal
        opened={archivedModalOpen}
        onClose={() => setArchivedModalOpen(false)}
      />
    </>
  );
};

export default SummaryModal;
